import {Component, Inject, Input, OnInit, ViewChild} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {faPlus} from '@fortawesome/free-solid-svg-icons';
import {environment} from '../../../../environments/environment';
import {Router} from '@angular/router';
import {faStar} from '@fortawesome/free-solid-svg-icons/faStar';
import {ProjectMeasureService} from '../../services/project-measure/project-measure.service';
import {ToastrService} from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';
import {AuthenticationService} from '../../services/authentication/authentication.service';

@Component({
  selector: 'app-graphical-view-list',
  templateUrl: './graphical-view-list.component.html',
  styleUrls: ['./graphical-view-list.component.css']
})
export class GraphicalViewListComponent implements OnInit {

  public faStar = faStar;
  public displayedColumns: string[] = ['id', 'viewName', 'featured', 'description', 'updatedAt', 'action1'];
  public views: MatTableDataSource<any>;
  public faPlus = faPlus;
  public showSpinner = false;
  @Input() projectId: number;
  @Input() isModal: boolean = true;
  @Input() isChipView: boolean = false;
  public pageSizeOptions = environment.pageSizeOptions;
  public pageSize = environment.pageSize;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  public chipViews: any;

  constructor(public activeModal: NgbActiveModal,
              private router: Router,
              private measureService: ProjectMeasureService,
              private toastr: ToastrService,
              private translate: TranslateService,
              private authenticationService : AuthenticationService) {
  }

  ngOnInit() {
    if(this.authenticationService.userHasRoleOsmos()){
      this.displayedColumns.push('action2');
      console.log(this.displayedColumns);
    }
    this.initList();
  }

  initList() {
    this.showSpinner = true;
    this.measureService.getSettingsGraphicalView(this.projectId).subscribe(
      (data: any) => {

        this.chipViews = data;
        let featured = [];
        let unFeatured = [];

          for (let chipViewsKey in this.chipViews) {
            if (this.chipViews[chipViewsKey].featured === true) {
              featured.push(this.chipViews[chipViewsKey]);
            } else {
              unFeatured.push(this.chipViews[chipViewsKey]);
            }
          }
          this.chipViews = featured.concat(unFeatured);


        this.views = new MatTableDataSource(data);
        this.views.filter = null;
        this.views.sort = this.sort;
        this.views.paginator = this.paginator;
        this.showSpinner = false;
      },
      error1 => {
        this.showSpinner = false;
      }
    );
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.views.filter = filterValue;
  }

  goToView(id: number) {
    this.activeModal.dismiss();
    this.router.navigate(['/chart/' + this.projectId]).then(() => {
      this.router.navigate(['/chart/' + this.projectId + '/view' + id]);
    });
  }

  deleteView(id: number) {
    this.showSpinner = true;
    this.measureService.deleteGraphicalComponentView(id).subscribe(
      (data: any) => {
        this.toastr.success(this.translate.instant('VIEW_DELETED'), this.translate.instant('SUCCESS'));
        this.showSpinner = false;
        this.initList();
      },
      error1 => {
        this.showSpinner = false;
      });
  }

}
